/* global axios */
import ApiClient from './ApiClient';

// NB: do NOT name the per-bot URL helper `baseUrl` -- ApiClient's `get url()`
// getter calls `this.baseUrl()`, so overriding it here recurses infinitely.
class KnowledgeEnrichmentEscalationReviewsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  scopedUrl(agentBotId) {
    return `${this.url}/${agentBotId}/knowledge_enrichment/escalation_reviews`;
  }

  index(agentBotId, { page = 1, status } = {}) {
    return axios.get(this.scopedUrl(agentBotId), { params: { page, status } });
  }

  dismiss(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/dismiss`);
  }
}

export default new KnowledgeEnrichmentEscalationReviewsAPI();
